import { encode, decode } from "./encode.js";
function createLocalStorage(baseOptions = {}) {
  return {
    set(key, value, localOptions = {}) {
      const opts = { ...baseOptions, ...localOptions };
      localStorage.setItem(`${opts.prefix ?? ""}${key}`, encode(value));
    },
    get(key, localOptions = {}) {
      const opts = { ...baseOptions, ...localOptions };
      const value = localStorage.getItem(`${opts.prefix ?? ""}${key}`);
      if (value == null)
        return null;
      return decode(value);
    },
    remove(key, localOptions = {}) {
      const opts = { ...baseOptions, ...localOptions };
      localStorage.removeItem(`${opts.prefix ?? ""}${key}`);
    },
    has(key, localOptions = {}) {
      const opts = { ...baseOptions, ...localOptions };
      return localStorage.getItem(`${opts.prefix ?? ""}${key}`) != null;
    },
    clear(localOptions = {}) {
      const opts = { ...baseOptions, ...localOptions };
      const keys = Object.keys(localStorage);
      for (const key of keys) {
        if (key.startsWith(opts.prefix ?? ""))
          localStorage.removeItem(key);
      }
    },
    keys(localOptions = {}) {
      const opts = { ...baseOptions, ...localOptions };
      const keys = Object.keys(localStorage);
      return keys.filter((key) => key.startsWith(opts.prefix ?? ""));
    }
  };
}
export {
  createLocalStorage
};
